/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const VLINDER_LOGO = require("./res/images/vLogo.png");

export const TRIBE_BG = require("./res/images/tribe_bg.jpeg");
export const CAL_BG = require("./res/images/CAL_BG.png");
export const PURE_BG = require("./res/images/pure_bg.jpeg");
export const HARTS_BG = require("./res/images/harts_bg.jpeg");
export const THE_LOST_TRIBE_BG1 = require("./res/images/the_lost_tribe_bg.jpeg");
export const THE_LOST_TRIBE_BG = require("./res/images/the_lost_tribe_bg2.jpg");
export const ROGUE_BG = require("./res/images/rogue_bg.jpeg");
export const SECRETS_BG = require("./res/images/Secrets_BG.png");
export const FOG_BG = require("./res/images/fog2026.png");
// TRIBE
export const TRIBE_TRUCK_START = require("./res/images/tribe_truck_start.png");
export const TRIBE_TRUCK_END = require("./res/images/tribe_truck_end.png");

// BLISS
export const BLISS_TRUCK_START = require("./res/images/bliss_truck_start.png");
export const BLISS_TRUCK_END = require("./res/images/bliss_truck_end.png");

// HARTS
export const HARTS_TRUCK_START = require("./res/images/harts_truck_start.png");
export const HARTS_TRUCK_END = require("./res/images/harts_truck_end.png");

// LOST TRIBE
export const LOST_TRUCK_START = require("./res/images/lt_truck_start.png");
export const LOST_TRUCK_END = require("./res/images/lt_truck_end.png");

export const PAYMENT_SUCCESS = require("./res/images/payment_success.png");
export const PAYMENT_FAILED = require("./res/images/payment_failed.png");
export const PAYMENT_PENDING = require("./res/images/payment_pending.png");

export const IMAGES = [
  VLINDER_LOGO,
  TRIBE_BG,
  CAL_BG,
  PURE_BG,
  HARTS_BG,
  THE_LOST_TRIBE_BG,
  ROGUE_BG,
  PAYMENT_SUCCESS,
  PAYMENT_FAILED,
  PAYMENT_PENDING,
];
